var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonJob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1206.000000, -1708.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Common/Job",
    transform: "translate(1206.000000, 1708.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9998,16.736 L31.9998,27 C31.9998,28.65 30.6508084,30 28.9998188,30 L28.9998188,30 L2.99998125,30 C1.34999156,30 0,28.65 0,27 L0,27 L0,16.739 C3.90697558,19.325 8.44094724,20.901 13.1999175,21.352 L13.1999175,21.352 L13.1999175,24 L18.7998825,24 L18.7998825,21.352 C23.5598528,20.9 28.0938244,19.324 31.9998,16.736 L31.9998,16.736 Z M32,8 L32,12.922 C27.525028,16.513 21.8960631,18.5 15.9981,18.5 C10.1021369,18.5 4.47417204,16.514 0.00019999875,12.926 L0.00019999875,12.926 L0.00019999875,8 L32,8 Z M19.2500797,3 C20.9000694,3 22.2500609,4.35 22.2500609,6 L22.2500609,6 L9.75013906,6 C9.75013906,4.35 11.1001306,3 12.7501203,3 L12.7501203,3 Z",
    id: 206
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonJob);
export default __webpack_public_path__ + "static/media/common-job.2387bf33.svg";
export { ForwardRef as ReactComponent };